var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgap2IT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.85 45.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffcd00;}.cls-2{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.69,20.18c0,3.65,2.2,6.14,5.31,6.14,1.89-.03,3.71-.75,5.1-2.04v-10.2c-1.6-.17-3.2-.25-4.8-.25-3.92,0-5.61,2.65-5.61,6.35m18.37-11.77v23.8h-7.96v-1.65c-1.92,1.6-4.35,2.45-6.84,2.39-5.73,0-11.26-4.55-11.26-13C.2,12.31,4.55,7.22,11.88,7.22c4.75.09,9.48.49,14.18,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m65.47,20.18c0,3.65,2.2,6.14,5.31,6.14,1.9-.04,3.72-.79,5.1-2.1v-10.14c-1.6-.17-3.2-.25-4.8-.25-3.92,0-5.61,2.65-5.61,6.35m18.37-11.77v23.8h-7.96v-1.65c-1.92,1.6-4.35,2.45-6.84,2.39-5.73,0-11.26-4.55-11.26-13,.2-7.65,4.55-12.75,11.88-12.75,4.75.09,9.48.49,14.18,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.18,34.73v-5.49l10.94-10.39c3.08-2.86,4.65-4.55,4.65-6.76,0-3.2-2.2-4.59-5.43-4.59-3.04.14-6.04.76-8.88,1.84l-1.73-6.94c3.81-1.47,7.85-2.28,11.94-2.39,8.49,0,12.26,5.04,12.26,10.88,0,5.06-3.31,8.86-7.73,12.9l-4.33,3.71h12.51v7.24h-24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.04,25.67c-1.68.26-3.38.37-5.08.35-3.01-.06-5.41-2.54-5.35-5.55,0-.11,0-.22.02-.33,0-3.71,1.71-6.35,5.63-6.35,1.6,0,3.2.09,4.78.25v11.63Zm-6.2-18.39c-7.37,0-11.77,5.1-11.86,12.75-.1,7.65,4.59,11.77,10,12.53.37,0,.92,0,1.59.12h1.8c1.73.08,3.42-.49,4.75-1.61.02.85-.04,1.69-.18,2.53.01.13.01.26,0,.39-.06.34-.15.68-.27,1h0c-.09.28-.22.55-.39.78-1.21,1.86-3.37,2.87-5.57,2.63-2.42-.14-4.82-.47-7.18-1l-1.14,6.2c2.78.92,5.68,1.43,8.61,1.51,9.33,0,14.12-5.22,14.12-13.26V8.31c-4.69-.71-9.43-1.11-14.18-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m100.59,26.02c-1.72.02-3.44-.1-5.14-.35v-11.59c1.61-.17,3.23-.25,4.84-.25,3.92,0,5.61,2.65,5.61,6.35.24,3-2,5.63-5,5.87-.1,0-.21.01-.31.02m1.06-18.75c-4.73.07-9.45.47-14.12,1.2v35.04h7.84v-12.82s1.51,1.96,6.94,1.96c5.88-.18,11.14-4.71,11.14-12.63s-4.49-12.75-11.88-12.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.03,32.12h-8.37V7.12h8.41l-.04,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.56,32.12h-8.41V14.47h-7.29v-7.35h23v7.35h-7.29v17.65Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgap2IT);
export default __webpack_public_path__ + "static/media/agap2iT.b3c46eae825554c689a37b89dc1cf728.svg";
export { ForwardRef as ReactComponent };